export enum ProdLocationsEnum {
	MaybourneBeverlyHills = 195,
}
